/**
 * Created by conormcquillan on 28/03/2017.
 */

angular.module('qkr').service('paginationService', () => {
    const service = {};
    const FIRST_PAGE = 1;
    const DEFAULT_PAGE_SIZE = 10;
    const NUM_PAGES = 10;

    service.getPages = getPages;

    return service;

    function getPages(totalItems, page, size) {
        // The current page the user navigates to, set to 1 by default
        const currentPage = page || FIRST_PAGE;
        const itemCount = totalItems || 0;

        // The number of items to be shown on a page, set to 10 by default
        const pageSize = size || DEFAULT_PAGE_SIZE;

        // Total pages depends on how many items exist and how many items are to be displayed per page.
        const totalPages = Math.ceil(itemCount / pageSize);
        let startPage;
        let endPage;

        if (totalPages > NUM_PAGES) {
            // More than 10 total pages so calculate start and end pages
            if (currentPage <= NUM_PAGES / 2 + 1) {
                startPage = FIRST_PAGE;
                endPage = NUM_PAGES;
            } else if (currentPage + (NUM_PAGES / 2 - 1) >= totalPages) {
                startPage = totalPages - (NUM_PAGES - 1);
                endPage = totalPages;
            } else {
                startPage = currentPage - (NUM_PAGES / 2);
                endPage = currentPage + (NUM_PAGES / 2 + 1);
            }
        } else {
            // Less than 10 total pages so show all
            startPage = FIRST_PAGE;
            endPage = totalPages;
        }

        const pages = _.range(startPage, endPage + FIRST_PAGE);
        return {
            totalItems,
            currentPage,
            pageSize,
            totalPages,
            startPage,
            endPage,
            pages
        };
    }
});



// WEBPACK FOOTER //
// ./src/services/pagination/pagination.service.js